import React, { FC } from 'react';
import {
  SectionBreadcrumbs,
  SectionBreadcrumbsProps,
} from '../../common/SectionBreadcrumbs';
import { SYSTEM_CLASSIFIER_ROUTES } from './SystemClassifiers';

export interface SystemClassifierBreadcrumbsData {
  code: string;
  name: string;
}

export type SystemClassifierBreadcrumbsProps = Omit<
  SectionBreadcrumbsProps<SystemClassifierBreadcrumbsData>,
  'routes'
>;

export const SystemClassifierBreadcrumbs: FC<
  SystemClassifierBreadcrumbsProps
> = (props) => (
  <SectionBreadcrumbs {...props} routes={SYSTEM_CLASSIFIER_ROUTES} />
);
